import * as Types from './Types';

export const openBillStatusNames = [ // eslint-disable-line
  Types.billStatusTypes.draft,
  Types.billStatusTypes.pendingApproval,
  Types.billStatusTypes.approved,
  Types.billStatusTypes.rejected,
];
